import React, { useState } from 'react';
import { Facebook, Twitter, Linkedin, Link as LinkIcon, Check, Share2 } from 'lucide-react';

// Icone WhatsApp (lucide n'en a pas, on utilise un SVG inline)
const WhatsAppIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M17.6 6.32A7.85 7.85 0 0 0 12.05 4a7.94 7.94 0 0 0-6.88 11.88L4 20l4.24-1.11a7.9 7.9 0 0 0 3.8.97h.01a7.94 7.94 0 0 0 7.94-7.94 7.9 7.9 0 0 0-2.39-5.6ZM12.05 18.5h-.01a6.6 6.6 0 0 1-3.36-.92l-.24-.14-2.51.66.67-2.45-.16-.25a6.6 6.6 0 1 1 12.24-3.53 6.6 6.6 0 0 1-6.63 6.63Zm3.62-4.93c-.2-.1-1.18-.58-1.36-.65-.18-.07-.31-.1-.44.1-.13.2-.51.65-.63.79-.12.13-.23.15-.43.05-.2-.1-.85-.31-1.62-1a6.1 6.1 0 0 1-1.13-1.4c-.12-.2-.01-.31.09-.41.09-.09.2-.24.31-.36.1-.12.14-.2.2-.34.07-.13.03-.25-.02-.36-.05-.1-.44-1.07-.6-1.46-.16-.38-.32-.33-.44-.34l-.37-.01a.72.72 0 0 0-.52.24 2.18 2.18 0 0 0-.68 1.62c0 .95.7 1.87.79 2 .1.13 1.37 2.1 3.33 2.94.47.2.83.32 1.11.41.47.15.9.13 1.23.08.38-.06 1.18-.48 1.34-.94.16-.47.16-.87.12-.95-.05-.09-.18-.14-.38-.24Z"/>
  </svg>
);

const ShareButtons = ({ title, url, className = '' }) => {
  const [copied, setCopied] = useState(false);
  const fullUrl = typeof window !== 'undefined'
    ? (url?.startsWith('http') ? url : `${window.location.origin}${url || window.location.pathname}`)
    : (url || '');
  const text = title ? `${title}\n\n` : '';
  const encodedUrl = encodeURIComponent(fullUrl);
  const encodedTitle = encodeURIComponent(title || '');
  const encodedText = encodeURIComponent(text);

  const links = [
    {
      name: 'WhatsApp',
      href: `https://api.whatsapp.com/send?text=${encodedText}${encodedUrl}`,
      icon: <WhatsAppIcon size={17} />,
      color: 'bg-[#25D366] hover:bg-[#1ea855] text-white',
    },
    {
      name: 'Facebook',
      href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      icon: <Facebook size={17} />,
      color: 'bg-[#1877F2] hover:bg-[#0f5cbb] text-white',
    },
    {
      name: 'Twitter',
      href: `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`,
      icon: <Twitter size={17} />,
      color: 'bg-[#1a1414] hover:bg-[#333] text-white',
    },
    {
      name: 'LinkedIn',
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
      icon: <Linkedin size={17} />,
      color: 'bg-[#0A66C2] hover:bg-[#084a8c] text-white',
    },
  ];

  const copyLink = async () => {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(fullUrl);
      } else {
        const ta = document.createElement('textarea');
        ta.value = fullUrl;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 2200);
    } catch (e) { /* ignore */ }
  };

  return (
    <div className={`border-t border-b border-[#e6ddd0] py-5 ${className}`}>
      <div className="flex flex-wrap items-center gap-3">
        <div className="flex items-center gap-2 text-[11px] uppercase font-bold tracking-[0.22em] text-[#3a3232] mr-2">
          <Share2 size={13} /> Partager
        </div>
        {links.map((l) => (
          <a
            key={l.name}
            href={l.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Partager sur ${l.name}`}
            title={`Partager sur ${l.name}`}
            className={`inline-flex items-center gap-2 px-4 py-2 text-[12px] font-semibold uppercase tracking-[0.14em] transition-colors ${l.color}`}
          >
            {l.icon}
            <span className="hidden sm:inline">{l.name}</span>
          </a>
        ))}
        <button
          onClick={copyLink}
          aria-label="Copier le lien"
          title="Copier le lien"
          className={`inline-flex items-center gap-2 px-4 py-2 text-[12px] font-semibold uppercase tracking-[0.14em] transition-colors border ${
            copied
              ? 'border-[#c9a961] bg-[#c9a961] text-[#1a1414]'
              : 'border-[#1a1414] text-[#1a1414] hover:bg-[#1a1414] hover:text-white'
          }`}
        >
          {copied ? <><Check size={14} /> Lien copié !</> : <><LinkIcon size={14} /> Copier le lien</>}
        </button>
      </div>
    </div>
  );
};

export default ShareButtons;
